import { Tooltip, TextField, Grid } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<Grid container spacing={5}>
			<Grid
				item
			>
				<Tooltip placement="top" title="Tooltip Top">
					<TextField defaultValue="Tooltip Top" />
				</Tooltip>
			</Grid>
			<Grid item>
				<Tooltip placement="right" title="Tooltip Right">
					<TextField defaultValue="Tooltip Right" />
				</Tooltip>
			</Grid>
			<Grid item>
				<Tooltip placement="bottom" title="Tooltip Bottom">
					<TextField defaultValue="Tooltip Bottom" />
				</Tooltip>
			</Grid>
			<Grid item>
				<Tooltip placement="left" title="Tooltip Left">
					<TextField defaultValue="Tooltip Left" />
				</Tooltip>
			</Grid>
		</Grid>
	);
};